import { CylinderType } from 'src/types/transforms';
import { createSize } from './CylinderWarpOutput';
import { createEllipse } from './Ellipse';

export const createTubeWarpInput = (): CylinderType => ({
    cylinderTop: createEllipse(),
    cylinderBottom: createEllipse(),
    decorationAreaDimensions: createSize(),
    productDiameter: 0,
    decorationExtentDegreesAlpha: 0,
    decorationExtentDegreesBeta: 0,
    isDecorationRotated: false,
    imageDimensions: createSize(),
    fullWrap: undefined,
    id: '',
    numberOfDecorationAreaPoints: 0,
});

export const getDecorationAreaExtent = (input: CylinderType): number => {
    let extent = input.isDecorationRotated
        ? input.decorationAreaDimensions.height
        : input.decorationAreaDimensions.width;
    extent = Math.min(Math.floor((input.productDiameter * Math.PI) / 2.0), extent);
    return extent;
};

export const getLeftDecorationAngle = (input: CylinderType): number => {
    const decorationExtent = getDecorationAreaExtent(input);
    const halfDecorationExtentRadians = Math.min(decorationExtent / input.productDiameter, Math.PI - 0.001);
    return normalizeAngle(Math.PI / 2 + halfDecorationExtentRadians);
};

export const getRightDecorationAngle = (input: CylinderType): number => {
    const decorationExtent = getDecorationAreaExtent(input);
    const halfDecorationExtentRadians = Math.min(decorationExtent / input.productDiameter, Math.PI - 0.001);
    return normalizeAngle(Math.PI / 2 - halfDecorationExtentRadians);
};

export const decorationAreaIsVisible = (input: CylinderType): boolean => {
    // if beta or alpha are in the visible region (180 - 360)
    return !(
        input.decorationExtentDegreesAlpha + input.decorationExtentDegreesBeta <= 180 ||
        (input.decorationExtentDegreesAlpha === 360 && input.decorationExtentDegreesBeta <= 180)
    );
};

export const normalizeAngle = (angle: number): number => {
    let normalized = angle;
    while (normalized > Math.PI) {
        normalized -= 2 * Math.PI;
    }
    while (normalized < -Math.PI) {
        normalized += 2 * Math.PI;
    }
    return normalized;
};
